import { render, staticRenderFns } from "./laporanpohon.vue?vue&type=template&id=3ae89481&scoped=true&"
import script from "./laporanpohon.vue?vue&type=script&lang=js&"
export * from "./laporanpohon.vue?vue&type=script&lang=js&"
import style0 from "./laporanpohon.vue?vue&type=style&index=0&id=3ae89481&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae89481",
  null
  
)

export default component.exports